export type ResolveApiResponse = {
  id: string;
  subscriptionName?: string;
  offerId?: string;
  planId?: string;
  quantity?: number | null;
  subscription?: {
    id: string;
    publisherId?: string;
    offerId?: string;
    name?: string;
    saasSubscriptionStatus?: string;
    beneficiary?: {
      emailId?: string;
      objectId?: string;
      tenantId?: string;
      puid?: string;
    };
    purchaser?: {
      emailId?: string;
      objectId?: string;
      tenantId?: string;
      puid?: string;
    };
    planId?: string;
    term?: {
      termUnit?: string;
      startDate?: string;
      endDate?: string;
    };
    autoRenew?: boolean;
    isTest?: boolean;
    isFreeTrial?: boolean;
    allowedCustomerOperations?: string[];
    sandboxType?: string;
    created?: string;
    lastModified?: string;
    sessionMode?: string;
    quantity?: number;
  };
};

export type Subscription = {
  id: string;
  name: string;
  status: string;
  plan: string;
  purchaserEmail: string;
  customerEmail: string;
  customerName: string;
  azureTenantId: string;
  quantity?: number | null;
};

const emailToName = (email?: string) => {
  const e = email || "";
  if (!e) return "";
  const user = e.split("@")[0] || "";
  return user
    .split(/[._-]+/)
    .filter(Boolean)
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
    .join(" ");
};

export function parseResolveResponse(resp: ResolveApiResponse): Subscription {
  if (!resp.subscription) {
    throw new Error("Subscription not found");
  }

  const sub = resp.subscription;
  const purchaserEmail = sub.purchaser?.emailId || "";
  const customerEmail = sub.beneficiary?.emailId || purchaserEmail;
  const name = resp.subscriptionName || sub.name || "(Unnamed subscription";
  const plan = resp.planId || sub.planId || "";
  const status = sub.saasSubscriptionStatus || "Unknown";
  const azureTenantId =
    sub.purchaser?.tenantId || sub.beneficiary?.tenantId || "";

  return {
    id: resp.id || sub.id || "",
    name,
    status,
    plan,
    purchaserEmail,
    customerEmail,
    customerName: emailToName(customerEmail) || emailToName(purchaserEmail),
    azureTenantId,
    quantity: typeof resp.quantity === "number" ? resp.quantity : sub.quantity,
  };
}
